import { ALPHANUMERIC_CHAR_TYPES } from "@/utils/checkCharTypeValidator";
import { validator } from "@/utils/validator";

export const masterDataSpecificActivityOccupationSchema = validator.object().shape({
  label: validator.string().emptyToNull().max(255).label("職種").required(),
  csvCode: validator
    .string()
    .emptyToNull()
    .autoTransformToHalfWidth()
    .isValidCheckCharType(ALPHANUMERIC_CHAR_TYPES)
    .length(3)
    .label("変更申請CSVのコード（列DN）")
    .required(),
});
